module.exports = __webpack_public_path__ + "img/BkgClientes.851dc856.jpg";